module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e582"
    }
  }, [_c('div', {
    staticClass: "tx44"
  }, [_c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151731"
    }
  }, [_vm._v("I am indebted to the writer and broadcaster Stephen")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151732"
    }
  }, [_vm._v("Fry for his comments; to Kim Harris and Sarah")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151733"
    }
  }, [_vm._v("Williams for their overpowering good taste and")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151734"
    }
  }, [_vm._v("intelligence; to my literary agent Anthony Goff, who")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151735"
    }
  }, [_vm._v("has been unstinting in his support and")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151736"
    }
  }, [_vm._v("encouragement; to my theatrical agent Lorraine")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151737"
    }
  }, [_vm._v("Hamilton, for not minding that I also have a literary")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151738"
    }
  }, [_vm._v("agent, and to my wife Jo, for things that would fill a")]), _vm._v(" "), _c('p', {
    staticClass: "tx14",
    attrs: {
      "id": "d41151739"
    }
  }, [_vm._v("longer book than this.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625d10c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap7_thegunse_9781569478004_epub_part7.vue
// module id = 72
// module chunks = 0